import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';

import { tap, catchError } from 'rxjs/operators';
import { WipperozProgressBarService } from 'app/wipperoz-core/components/progress-bar/progress-bar.service';

@Injectable({ providedIn: 'root' })
export class Interceptor implements HttpInterceptor {
  constructor(private _wipperozProgressBarService: WipperozProgressBarService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.sendRequest(req, next);
  }

  private showLoader(): void {
    this._wipperozProgressBarService.show();
  }

  private hideLoader(): void {
    this._wipperozProgressBarService.hide();
  }

  private onEnd(): void {
    this.hideLoader();
  }

  private sendRequest(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.showLoader();
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
        } else {
          return throwError(error);
        }
      }),
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.onEnd();
          }
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (err: any) => {
          this.onEnd();
        }
      )
    );
  }
}
